import React from 'react';
import styled from 'styled-components';
import { CompressedImage } from 'web-services/Imgix';
import { BodyBoldLargeStyles, BodySmallBoldSmallStyles, LabelLargeStyles, BodySmallSmallStyles } from 'web-ui-kit/typography';
import { primaryHighlightM, grayMediumHighlightM, grayLightM, selectedMediumHighlightM, primaryDisabledM } from 'web-ui-kit/colors';
import { toUSDString, truncateLines } from 'web-ui-kit/styleUtils';
import { cartPopupHeroImageClicked, cartPopupRemoveItemClicked, cartPopupQtyDecClicked, cartPopupQtyIncClicked } from 'web-ui-kit/CartPopupEvents';
import DeleteIcon from 'web-ui-kit/assets/DeleteIcon';
import MinusIcon from 'web-ui-kit/assets/MinusIcon';
import PlusIcon from 'web-ui-kit/assets/PlusIcon';
import { MQ_FOR_TABLET_LANDSCAPE_UP } from 'web-ui-kit/media';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;

function CartItem(_ref) {
  var _ref$CART_STATUS = _ref.CART_STATUS,
      CART_STATUS = _ref$CART_STATUS === void 0 ? '' : _ref$CART_STATUS,
      _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$heroImg = _ref.heroImg,
      heroImg = _ref$heroImg === void 0 ? '' : _ref$heroImg,
      _ref$productId = _ref.productId,
      productId = _ref$productId === void 0 ? '' : _ref$productId,
      _ref$isUpdating = _ref.isUpdating,
      isUpdating = _ref$isUpdating === void 0 ? false : _ref$isUpdating,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      _ref$regularPrice = _ref.regularPrice,
      regularPrice = _ref$regularPrice === void 0 ? 0 : _ref$regularPrice,
      _ref$salePrice = _ref.salePrice,
      salePrice = _ref$salePrice === void 0 ? 0 : _ref$salePrice,
      _ref$quantity = _ref.quantity,
      quantity = _ref$quantity === void 0 ? 0 : _ref$quantity,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'hover' : _ref$variant;
  var Controls = styles.Controls,
      Name = styles.Name,
      Prices = styles.Prices,
      ProductDetails = styles.ProductDetails,
      ProductImage = styles.ProductImage,
      ProductImageContainer = styles.ProductImageContainer,
      ProductMeta = styles.ProductMeta,
      Quantity = styles.Quantity,
      RegularPrice = styles.RegularPrice,
      SalePrice = styles.SalePrice,
      StrikeThroughPrice = styles.StrikeThroughPrice,
      StyledDeleteIcon = styles.StyledDeleteIcon;
  return (
    /*#__PURE__*/
    React.createElement(ProductDetails, {
      "data-testid": "cart-product-".concat(productId)
    },
    /*#__PURE__*/
    React.createElement(ProductImageContainer, {
      onClick: function onClick() {
        dispatch(cartPopupHeroImageClicked({
          productId: productId
        }));
      }
    },
    /*#__PURE__*/
    React.createElement(ProductImage, {
      bucketName: "modsy",
      src: heroImg,
      height: 72,
      width: 72
    })),
    /*#__PURE__*/
    React.createElement(ProductMeta, null,
    /*#__PURE__*/
    React.createElement(Name, null, name),
    /*#__PURE__*/
    React.createElement(Prices, null, salePrice > 0 &&
    /*#__PURE__*/
    React.createElement(SalePrice, null, toUSDString(salePrice)), salePrice > 0 && regularPrice > 0 &&
    /*#__PURE__*/
    React.createElement(StrikeThroughPrice, null, toUSDString(regularPrice)), salePrice <= 0 && regularPrice > 0 &&
    /*#__PURE__*/
    React.createElement(RegularPrice, null, toUSDString(regularPrice))), variant === 'items-added' && quantity > 1 &&
    /*#__PURE__*/
    React.createElement(Quantity, null, "Qty: ".concat(quantity))), variant === 'hover' && CART_STATUS !== 'UPGRADES_ONLY' &&
    /*#__PURE__*/
    React.createElement(Controls, null,
    /*#__PURE__*/
    React.createElement(QuantityPicker, {
      dispatch: dispatch,
      isUpdating: isUpdating,
      productId: productId,
      quantity: quantity
    }),
    /*#__PURE__*/
    React.createElement("div", {
      onClick: function onClick(e) {
        dispatch(cartPopupRemoveItemClicked({
          currentQty: quantity,
          disabled: isUpdating,
          productId: productId,
          jsEvent: e
        }));
      }
    },
    /*#__PURE__*/
    React.createElement(StyledDeleteIcon, {
      disabled: isUpdating,
      width: 17
    }))))
  );
}

function QuantityPicker(_ref2) {
  var dispatch = _ref2.dispatch,
      isUpdating = _ref2.isUpdating,
      productId = _ref2.productId,
      quantity = _ref2.quantity;
  var QuantityPickerWrapper = styles.QuantityPickerWrapper,
      StyledButton = styles.StyledButton,
      StyledMinusIcon = styles.StyledMinusIcon,
      StyledPlusIcon = styles.StyledPlusIcon;
  return (
    /*#__PURE__*/
    React.createElement(QuantityPickerWrapper, null,
    /*#__PURE__*/
    React.createElement(StyledButton, {
      disabled: isUpdating,
      onClick: function onClick(e) {
        dispatch(cartPopupQtyDecClicked({
          currentQty: quantity,
          disabled: isUpdating,
          productId: productId,
          jsEvent: e
        }));
      }
    },
    /*#__PURE__*/
    React.createElement(StyledMinusIcon, {
      width: 10
    })), quantity,
    /*#__PURE__*/
    React.createElement(StyledButton, {
      disabled: isUpdating,
      onClick: function onClick(e) {
        dispatch(cartPopupQtyIncClicked({
          currentQty: quantity,
          disabled: isUpdating,
          productId: productId,
          jsEvent: e
        }));
      }
    },
    /*#__PURE__*/
    React.createElement(StyledPlusIcon, {
      width: 10
    })))
  );
}

var PriceStylesCommon = styled.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), BodyBoldLargeStyles);
var styles = {
  Controls: styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-end;\n    height: 100%;\n  "]))),
  ProductDetails: styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: 4.5rem 2fr 1fr;\n    grid-column-gap: 0.5rem;\n    align-items: center;\n    margin-bottom: 1rem;\n\n    ", " {\n      grid-column-gap: .5rem;\n      margin-bottom: 1rem;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP),
  ProductImageContainer: styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    height: 0;\n    padding-bottom: 100%;\n\n    border-radius: 4px;\n    position: relative;\n  "]))),
  ProductImage: styled(CompressedImage)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    border-radius: 4px;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n  "]))),
  ProductMeta: styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n  "]))),
  Name: styled.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: 0.125rem;\n    ", ";\n\n    ", " {\n      ", ";\n    }\n  "])), BodySmallBoldSmallStyles, truncateLines({
    lines: 1
  }), MQ_FOR_TABLET_LANDSCAPE_UP, truncateLines({
    lines: 2
  })),
  Prices: styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    margin-bottom: 0.5rem;\n\n    > p:nth-of-type(1) {\n      margin-right: 0.25rem;\n    }\n  "]))),
  QuantityPickerWrapper: styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    ", ";\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n  "])), BodyBoldLargeStyles),
  RegularPrice: styled(PriceStylesCommon)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral([""]))),
  SalePrice: styled(PriceStylesCommon)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), primaryHighlightM),
  StrikeThroughPrice: styled(PriceStylesCommon)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    ", ";\n    line-height: 1rem;\n    color: ", ";\n    text-decoration: line-through;\n  "])), LabelLargeStyles, grayMediumHighlightM),
  StyledButton: styled.button(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    /* reset default button styles */\n    appearance:  none;\n    background: none;\n    border: none;\n    outline: none;\n    padding: 0;\n\n    /* fixed height and width */\n    height: 1.5rem;\n    width: 1.5rem;\n\n    /* center icon */\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    border-radius: 50%;\n    cursor: pointer;\n    transition: all 100ms ease-out;\n\n    @media (hover: hover) {\n      &:hover:not([disabled]) {\n        background-color: ", ";\n      }\n    }\n\n    ", "\n\n    ", "\n  "])), grayLightM, function (p) {
    return p.active && "background-color: ".concat(selectedMediumHighlightM, " !important;");
  }, function (p) {
    return p.disabled && "\n      cursor: initial;\n      svg path {\n        fill: ".concat(primaryDisabledM, ";\n      }\n    ");
  }),
  StyledDeleteIcon: styled(DeleteIcon)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    height: 1.5rem;\n    cursor: pointer;\n    margin-right: 0.25rem;\n    margin-bottom: 0.5rem;\n\n    ", "\n  "])), function (p) {
    return p.disabled && "\n      cursor: initial;\n      opacity: 0.6;\n    ";
  }),
  StyledMinusIcon: styled(MinusIcon)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 0.875rem;\n  "]))),
  StyledPlusIcon: styled(PlusIcon)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 0.875rem;\n  "]))),
  Quantity: styled.p(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    ", ";\n  "])), BodySmallSmallStyles),
  ControlsRow: styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n  "])))
};
export default CartItem;
export { styles };